import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import GoogleAnalytics from "components/GoogleAnalytics";
// Add your imports here
import HomeLandingPage from "pages/home-landing-page";
import WorkExperience from "pages/work-experience";
import ContactResume from "pages/contact-resume";
import SkillsTechnicalExpertise from "pages/skills-technical-expertise";
import AboutProfessionalBackground from "pages/about-professional-background";
import ProjectPortfolio from "pages/project-portfolio";
import NotFound from "pages/NotFound";
import TermsConditions from "pages/terms-conditions";
import PrivacyPolicy from "pages/privacy-policy";
import BlogPage from "pages/blog";
import SingleBlogPage from "pages/single-blog";
import Layout from "components/Layout";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <GoogleAnalytics />
        <ScrollToTop />
        <Layout>
          <RouterRoutes>
            {/* Define your routes here */}
            <Route path="/" element={<HomeLandingPage />} />
            <Route path="/about" element={<AboutProfessionalBackground />} />
            <Route path="/skills" element={<SkillsTechnicalExpertise />} />
            <Route path="/projects" element={<ProjectPortfolio />} />
            <Route path="/experience" element={<WorkExperience />} />
            <Route path="/contact" element={<ContactResume />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<SingleBlogPage />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </Layout>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;